<template>
  <div class="main-layout div-scroll">
    <el-card class="box-search">
      <c-search v-model="pageParams" @reset="refresh" @search="pageGet(true)">
        <!-- :searchItems="searchItems" -->
        <el-col :span="12" class="c-search-item">
          <el-form-item label="录取专业">
            <el-select
              v-model="pageParams.originalMajorId"
              filterable
              placeholder="请选择"
              clearable
              @change="handleOriginChange"
            >
              <el-option
                v-for="item in majorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="c-search-item">
          <el-form-item label="拟调配专业" :label-width="'100px'">
            <el-select
              v-model="pageParams.applyMajorId"
              filterable
              clearable
              placeholder="请选择"
              @change="handleApplyChange"
            >
              <el-option
                v-for="item in majorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </c-search>
    </el-card>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <div></div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
        @showDetail="handleToDetail"
      >
        <!-- <template slot="custom" slot-scope="scope">
          <el-button
            type="primary"
            @click="handleToDetail(scope.row)"
            class="leave-btn"
            >详情</el-button
          >
        </template> -->
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import Configs from "../data/major";
let mPage = MPage({
  pagePath: "/oa/welcome/exchangeMajor/getTodoListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    originalMajorId: "",
    applyMajorId: "",
  },
});
export default {
  name: "",
  components: {
    CSearch,
    CTable,
    TableBtns,
  },
  mixins: [mPage],
  data() {
    let { searchItems, tableColumnsAudit } = Configs(this);
    return {
      SUCCESS_CODE: "",
      searchItems,
      tableColumns: tableColumnsAudit,
      userId: "",
      majorOptions: [],
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getMajorOptions();
    this.pageParams.originalMajorId = localStorage.getItem('originalMajorId') || '';
    this.pageParams.applyMajorId = localStorage.getItem('applyMajorId') || '';
  },
  mounted() {},
  methods: {
    selectionChange() {},
    refresh() {
      localStorage.removeItem('originalMajorId');
      localStorage.removeItem('applyMajorId');
      this.pageParams = {
        originalMajorId: "",
        applyMajorId: "",
      };
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      data.userId = this.userId;
      localStorage.setItem('originalMajorId',data.originalMajorId)
      localStorage.setItem('applyMajorId',data.applyMajorId)
    },
    pageGetAfterFn(data) {
      data.records = data.rows;
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 查看详情
    handleToDetail(data) {
      this.$router.push({
        path: "/welcome/teacher/predicted/majorDetail",
        query: {
          id: data.processInstanceId,
          type: "todo",
          studentId: data.studentId,
          taskId: data.taskId,
        },
      });
    },
    // 获取专业列表
    getMajorOptions() {
      this.$http
        .get("/welcome-live/exchange/rule/getMajorListByRuleId/0")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            let data = res.data;
            this.majorOptions = data.map((item) => {
              return {
                label: item.majorName,
                value: item.majorId,
              };
            });
          } else {
            this.majorOptions = [];
          }
        })
        .catch((err) => {
          this.majorOptions = [];
        });
    },
    handleOriginChange(data){
      console.log(data)
      
    },
    handleApplyChange(data){
      console.log(data)
      
    },
  },
};
</script>
